import { CSSProperties } from "react";

import { useTheme } from "@hooks";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    date: {
      color: theme.text.secondary,
    },
  };

  return styles;
};
